// External packages
import * as ReactAria from 'react-aria-components';
import * as React from 'react';

// Components
import { Button } from 'components/Button';
import * as Modal from 'components/Modal';
import { Icon } from 'components/Icons';

// Hooks
import { useDeleteMedia } from 'api/media';

export interface MediaModalProps {
  modalTrigger?: React.ReactNode;
  media: { id: string; url: string; altText?: string };
  fileType: 'images' | 'videos' | 'audio' | 'placeMaps';
  renderMedia: (media: { url: string; altText?: string }) => React.ReactNode;
  disableDelete?: boolean;
}

export const MediaModal: React.FC<MediaModalProps> = ({
  modalTrigger,
  media,
  fileType,
  renderMedia,
  disableDelete = false,
}) => {
  const [copied, setCopied] = React.useState(false);
  const { mutate: deleteMedia, isPending: isDeleting } = useDeleteMedia();

  const handleDelete = () => {
    deleteMedia({ fileType, id: media.id });
  };

  const copyId = () => {
    navigator.clipboard.writeText(media.id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Modal.TriggerRoot>
      {modalTrigger}
      <Modal.Overlay isDismissable>
        <ReactAria.Modal>
          <ReactAria.Dialog>
            <Modal.Close className="text-white [&>svg]:size-8" />
            <div>
              {renderMedia(media)}
              <div className="flex flex-wrap gap-4 mt-8">
                <Button size="lg" className="flex-4" onPress={copyId}>
                  {copied ? (
                    <Icon name="check" className="size-6" />
                  ) : (
                    'Kopiraj ID'
                  )}
                </Button>
                {!disableDelete && (
                  <Button
                    size="lg"
                    colorScheme="tertiary"
                    className="flex-1 whitespace-nowrap"
                    onPress={handleDelete}
                    isPending={isDeleting}
                  >
                    Izbriši{' '}
                    {fileType === 'images'
                      ? 'sliku'
                      : fileType === 'videos'
                        ? 'video'
                        : fileType === 'audio'
                          ? 'audio'
                          : 'mapu'}
                  </Button>
                )}
              </div>
            </div>
          </ReactAria.Dialog>
        </ReactAria.Modal>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
